import { useQueryClient } from "@tanstack/react-query";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { postApiChunkFormData } from "../helpers/AxiosInstance";
import APIS from "../constant/Endpoint";
interface Props {
  queryKey: string[];
  setIsUploading: React.Dispatch<React.SetStateAction<boolean>>;
}
const useUploadFileHook = (props: Props) => {
  const queryClient = useQueryClient();
  const { setIsUploading, queryKey } = props;
  const [progress, setProgress] = useState(0);
  const uploadFile = async (file, fileId, productId) => {
    const CHUNK_SIZE = 1 * 1024 * 1024;
    const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
    const url = `${APIS.FILE_HANDLER}chunk-upload/`;
    // const timestamp = Date.now();
    // const title = `MyUpload ${timestamp}`;
    setIsUploading(true);
    for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
      const start = chunkIndex * CHUNK_SIZE;
      const end = Math.min(start + CHUNK_SIZE, file.size);
      const chunk = file.slice(start, end);
      const chunkFormData = new FormData();
      chunkFormData.append("file", chunk);
      chunkFormData.append("file_id", fileId);
      chunkFormData.append("chunk_index", chunkIndex.toString());
      chunkFormData.append("total_chunks", totalChunks.toString());
      const filteredTitle = file?.name.replace(/[^a-zA-Z.]/g, "");
      chunkFormData.append("title", filteredTitle);
      if (productId) chunkFormData.append("object_id", productId);
      chunkFormData.append("folder", "Document");
      chunkFormData.append("is_private", "true");
      chunkFormData.append("service", "Document Upload");

      try {
        const res = await postApiChunkFormData({
          url,
          formData: chunkFormData,
          setProgress,
          chunkIndex,
          totalChunks,
        });

        if (res.status === 201 && chunkIndex === totalChunks - 1) {
          queryClient.invalidateQueries({
            queryKey: queryKey,
            refetchType: "active",
          });
          toast.success("Uploaded Successfully");

          return res?.data?.path;
        } else if (chunkIndex === totalChunks - 1) {
          toast.error("Upload failed");
        }
      } catch (err) {
        console.error(err);
      } finally {
        setIsUploading(false);
      }
    }
  };

  return { progress, uploadFile };
};

export default useUploadFileHook;
